/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Platforms_PcInputs */

const en_pc_cmp_r_platforms_pc = /** @type {(inputs: Pc_Cmp_R_Platforms_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux, FreeBSD, web`)
};

const zh_pc_cmp_r_platforms_pc = /** @type {(inputs: Pc_Cmp_R_Platforms_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、Linux、FreeBSD、网页`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux, FreeBSD, web" |
*
* @param {Pc_Cmp_R_Platforms_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_platforms_pc = /** @type {((inputs?: Pc_Cmp_R_Platforms_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Platforms_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_platforms_pc(inputs)
	return zh_pc_cmp_r_platforms_pc(inputs)
});
export { pc_cmp_r_platforms_pc as "pc.cmp.r.platforms.pc" }